export default {
  index: [
    {
      path: '/qygssb',
      component: resolve => require(['./qygssbIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qy_gssb/_router.js